import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { logOut, updateLocalStorageToken } from '../../../../../containers/resources/utils';

export const customCharterRateForm = createSlice({
  name: 'customCharterRateForm',
  initialState: {
    rates: [],
    yachts: [],
    days: [],
    charterRate: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateCharterRateFormCustom(state, action) {
      return {
        rates: [],
        yachts: [],
        days: [],
        charterRate: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesCharterRateFormCustom(state, action) {
      return {
        rates: [],
        yachts: [],
        days: [],
        charterRate: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchCharterRateFormCustomSuccess(state, action) {
      return {
        rates: action.payload.rates,
        yachts: action.payload.yachts,
        days: action.payload.days,
        charterRate: action.payload.charterRate,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchCharterRateFormCustomError(state, action) {
      return {
        rates: [],
        yachts: [],
        days: [],
        charterRate: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchCharterRateFormCustom = (charterRate_id) => dispatch => {
  dispatch(requesCharterRateFormCustom());
  axios.get(`/charterRates/form/charterRatesForm?charterRate_id=${charterRate_id}`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchCharterRateFormCustomSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchCharterRateFormCustom(charterRate_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchCharterRateFormCustomError(json.data.data));
      }
    })
};

export const {
  initialStateCharterRateFormCustom,
  requesCharterRateFormCustom,
  fetchCharterRateFormCustomSuccess,
  fetchCharterRateFormCustomError,
} = customCharterRateForm.actions;

export default customCharterRateForm.reducer;